import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class PatientFolderResource {
  private baseUri = '/prl/patientFolders';

  constructor(private ApiService: ApiService) {}

  // GET
  getPatientFolder(params: {
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
  }): Observable<Docorga.interfaces.patientFolder.IPatientFolderJson> {
    return this.ApiService.get(`${this.baseUri}/${params.patientFolderId}`, params);
  }

  fetchPatientFolderForPatient(params: {
    patientId: Docorga.interfaces.naturalTypes.NPatientObjectId;
    expertizeId: Docorga.interfaces.naturalTypes.NExpertizeObjectId | undefined;
  }): Observable<Docorga.interfaces.patientFolder.IPatientFolderJson | undefined> {
    return this.ApiService.get(`${this.baseUri}/patientFolder`, params);
  }

  findPatientFolders(params: {
    filter: Docorga.interfaces.patientFolder.IPatientFolderFilter;
  }): Observable<Array<Docorga.interfaces.patientFolder.IPatientFolderExtendedJson>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }

  // POST
  createPatientFolder(params: {
    praticienId: string;
    patientId: Docorga.interfaces.naturalTypes.NPatientObjectId;
  }): Observable<Docorga.interfaces.patientFolder.IPatientFolderJson | undefined> {
    return this.ApiService.post(`${this.baseUri}/createPatientFolder`, params);
  }

  // PUT
  updatePatientFolderForm(params: {
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
    form: Docorga.interfaces.patientFolder.IPatientFolderJson['form'];
  }): Observable<Docorga.interfaces.patientFolder.IPatientFolderJson['status']> {
    return this.ApiService.put(`${this.baseUri}/${params.patientFolderId}/updateForm`, params);
  }

  updatePatientFolderStatus(params: {
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
    status: Docorga.interfaces.patientFolder.IPatientFolderJson['status'];
    message?: string;
  }): Observable<void> {
    return this.ApiService.put(`${this.baseUri}/${params.patientFolderId}/updatePatientFolderStatus`, params);
  }

  updatePatientFolderInterestDates(params: { patientFolderId: string }): Observable<void> {
    return this.ApiService.put(`${this.baseUri}/${params.patientFolderId}/updatePatientFolderInterestDates`, params);
  }
}
